export default __webpack_public_path__ + "static/media/1984.a28c8700.png";